import React, { useEffect } from "react";
import { Form as FormikForm, FormikProps, FormikConfig, useFormik, FormikProvider } from "formik";

import { ActionsSection, ButtonsSection } from "../data-components/sections/DataSections";
import SaveButton from "../buttons/save-button/SaveButton";
import CancelButton from "../buttons/cancel-button/CancelButton";
import { TranslationContext } from "../../services/translation/TranslationService";
import { warningLeavePageService } from "../../services/page/WarningLeavePageService";

interface FormProps {
  formikOptions: FormikConfig<any>;
  warningKey?: string;
  warningContext?: TranslationContext;
  canSubmit?: boolean;
  rightSideActionButton?: JSX.Element;
  onCancel(): void;
  children(formikProps: FormikProps<any>): JSX.Element;
  saveButtonText?: string;
}

export default function Form(props: FormProps) {
  const {
    children,
    formikOptions,
    onCancel,
    warningKey,
    warningContext,
    canSubmit = true,
    rightSideActionButton,
    saveButtonText,
  } = props;

  const formik = useFormik({ ...formikOptions });
  const { dirty, isSubmitting } = formik;

  useEffect(() => {
    warningLeavePageService.setIsDirty(dirty);
    warningLeavePageService.setIsSubmitting(isSubmitting);
  }, [dirty, isSubmitting]);

  return (
    <FormikProvider value={formik}>
      <FormikForm>
        <ActionsSection warningKey={warningKey} warningContext={warningContext}>
          <ButtonsSection>
            <SaveButton saveButtonText={saveButtonText} disabled={!canSubmit || isSubmitting} />
            <CancelButton onClick={onCancel} />
          </ButtonsSection>
          {rightSideActionButton && <ButtonsSection>{rightSideActionButton}</ButtonsSection>}
        </ActionsSection>
        {children(formik)}
      </FormikForm>
    </FormikProvider>
  );
}
